import { useQuery } from 'react-query';
import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import BuyerBriefResponse from '../../types/BuyerBriefResponse';

interface UseFetchBuyerBriefProps {
  briefId: string;
  enabled?: boolean;
}

export const useFetchBuyerBrief = ({ briefId, enabled = true }: UseFetchBuyerBriefProps) =>
  useQuery<BuyerBriefResponse>(
    ['BuyerBriefOverview', briefId],
    async () => {
      const { data } = await axios.get(pathfinder('get_dm_brief_buyer_overview', { briefId }));
      return data;
    },
    { refetchOnWindowFocus: false, enabled }
  );
